import React, { useState } from 'react';
import { Button, Box } from '@mui/material';
import Loader from '../../components/Loader';
import { SchoolClassesConfig } from '../../types/schoolConfigType';
import { downloadReport } from '../../utils/reportUtils';
import { PageWrapper, Title } from '../common/styled';
import { buildDownloadRows } from './utils';
import { DownloadButtonSection } from './styled';
import {
  StudentOutstandingDetail,
  ClassWiseTotal,
  GrandTotal,
  OutstandingFeeFilters,
  ComponentsFilterConfig
} from './types';
import OutstandingFeeByClassReportTable from './OutstandingFeeByClassReportTable';
import OutstandingFeeByClassReportFilters from './components/ReportFilters';

interface Props {
  studentRows: StudentOutstandingDetail[] | null;
  classWiseTotal: ClassWiseTotal[];
  grandTotal: GrandTotal | null;
  allClasses: SchoolClassesConfig;
  onSearch: (filters: OutstandingFeeFilters) => void;
  onReset: () => void;
  loading: boolean;
  school: string;
  componentsFilterConfig?: ComponentsFilterConfig;
}

const OutstandingFeeByClassReport: React.FC<Props> = ({
  studentRows,
  classWiseTotal,
  grandTotal,
  allClasses,
  onSearch,
  onReset,
  loading,
  school,
  componentsFilterConfig
}) => {
  const [lastAsOnDate, setLastAsOnDate] = useState<string>('');

  const handleSearch = (filters: OutstandingFeeFilters) => {
    setLastAsOnDate(filters.asOnDate ?? '');
    onSearch(filters);
  };

  const handleDownload = () => {
    if (!studentRows || !grandTotal) return;
    const rows = buildDownloadRows(
      studentRows,
      classWiseTotal,
      grandTotal,
      school
    );
    const fileName = lastAsOnDate
      ? `${school}-OutstandingFeeByClassReport-AsOn-${lastAsOnDate}`
      : `${school}-OutstandingFeeByClassReport`;
    downloadReport(
      rows as any[],
      fileName,
      'Outstanding Fee by Class',
      () => {}
    );
  };

  const hasData = studentRows !== null && grandTotal !== null;

  return (
    <>
      <Title>Outstanding Fee Report by Class</Title>
      <OutstandingFeeByClassReportFilters
        allClasses={allClasses}
        loading={loading}
        onSearch={handleSearch}
        onReset={onReset}
        componentsFilterConfig={componentsFilterConfig}
      />
      <PageWrapper sx={{ display: loading || hasData ? '' : 'none' }}>
        {loading ? (
          <Loader show showFullScreen />
        ) : (
          hasData &&
          grandTotal && (
            <Box>
              <DownloadButtonSection>
                <Button variant='contained' onClick={handleDownload}>
                  Download
                </Button>
              </DownloadButtonSection>
              <OutstandingFeeByClassReportTable
                studentRows={studentRows!}
                classWiseTotal={classWiseTotal}
                grandTotal={grandTotal}
                school={school}
              />
            </Box>
          )
        )}
      </PageWrapper>
    </>
  );
};

export default OutstandingFeeByClassReport;
